import React, { Component } from 'react';
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ChartLoader from '../../Loaders/ChartLoader';

import { chartBlue, chartRed, chartYellow } from '../../../shared/config';
import Auth from '../../../shared/Auth';
import axios from '../../../utils/axiosClient';

require('highcharts/modules/drag-panes')(Highcharts);

Highcharts.setOptions({
  global: {
    useUTC: false,
  },
});

class CurrentProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initialize: true,
      options: {},
    };
    this.chart = null;
    this.fetchData = this.fetchData.bind(this);
  }

  componentDidMount() {
    this.fetchData(this.props.deviceId, 1); // 1 NumberOfMonths
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({ initialize: true });

    if (this.props.widgetSetting.w1Size !== nextProps.widgetSetting.w1Size) {
      this.fetchData(nextProps.deviceId, 1); // 1 NumberOfMonths
    }

    if (this.props.deviceId !== nextProps.deviceId) {
      this.fetchData(nextProps.deviceId, 1); // 1 NumberOfMonths
    } else if (
      this.props.selectedObj.StartTime !== nextProps.selectedObj.StartTime
    ) {
      const strDt = nextProps.selectedObj.StartTime.replace('T', ' ');
      const endDt = Date.parse(nextProps.selectedObj.EndTime.replace('T', ' '));
      const tmstmp = Date.parse(strDt);
      if (this.state.options !== null) {
        const _options = this.state.options;
        // //added 5 hours for showing that line in bit inside of box
        const dt = new Date(strDt);
        const newdt = dt.setHours(dt.getHours() + 5);

        const obj = {
          len: _options.series?.[0]?.data?.length ?? 0,

          min: dt,
          max: newdt,
          selectedPoint: tmstmp,
          endPoint: endDt,
          current_R: _options.series?.[0]?.data ?? [],
          current_Y: _options.series?.[1]?.data ?? [],
          current_B: _options.series?.[2]?.data ?? [],
        };
        setTimeout(() => {
          this.plotGraph(obj);
        }, 1000);
      }
    }
  }

  async fetchData(deviceId, NumberOfMonths) {
    const checkToken = await Auth();
    if (checkToken) {
      axios
        .get(`report/currentprofile/${deviceId}/${NumberOfMonths}`) // 1 size
        .then((response) => {
          if (response.data.statusCode === 200) {
            const current_R = [];
            const current_Y = [];
            const current_B = [];

            const data = response.data.result;

            if (data.length > 0) {
              data.forEach(async (element) => {
                const tmstmp = Date.parse(element.timeStamp.replace('_', ' '));
                current_R.push([tmstmp, parseFloat(element.current1)]);
                current_Y.push([tmstmp, parseFloat(element.current2)]);
                current_B.push([tmstmp, parseFloat(element.current3)]);
              });
            }

            let selectedPoint;
            let endPoint;
            let min;
            let max;
            if (this.props.selectedObj) {
              const dt = new Date(
                this.props.selectedObj.StartTime.replace('T', ' ')
              );

              const newdt = dt.setHours(dt.getHours() + 10);
              min = dt;
              max = newdt;
              selectedPoint = Date.parse(
                this.props.selectedObj.StartTime.replace('T', ' ')
              );
              endPoint = Date.parse(
                this.props.selectedObj.EndTime.replace('T', ' ')
              );
              // limitPoint = this.props.selectedObj.limitToShow;
            }

            const obj = {
              len: data.length,
              min,
              max,
              selectedPoint,
              endPoint,
              current_R,
              current_Y,
              current_B,
            };
            this.plotGraph(obj, NumberOfMonths);
          } else {
            // this.setState({ initialize: false });
            const obj = {
              len: [],
              min: '',
              max: '',
              selectedPoint: '',
              endPoint: '',
              current_R: [],
              current_Y: [],
              current_B: [],
            };
            this.plotGraph(obj, NumberOfMonths);
          }
        })
        .catch((error) => {
          console.log(error);
          const obj = {
            len: [],
            min: '',
            max: '',
            selectedPoint: '',
            endPoint: '',
            current_R: [],
            current_Y: [],
            current_B: [],
          };
          this.plotGraph(obj, NumberOfMonths);
        });
    }
  }

  plotGraph(obj, NumberOfMonths) {
    const _self = this;
    this.setState({
      options: {
        chart: {
          renderTo: 'CurrentVsTimeChartContainer',
          type: 'line',
        },
        rangeSelector: {
          buttons: [
            {
              type: 'day',
              count: 1,
              text: '1d',
            },
            {
              type: 'week',
              count: 1,
              text: '1w',
            },
            {
              type: 'month',
              count: 1,
              text: '1m',
            },
            {
              type: 'all',
              text: '6m',
              events: {
                click() {
                  _self.setState({ initialize: true }, () =>
                    _self.fetchData(_self.props.deviceId, 6)
                  );
                },
              },
            },
          ],
          inputEnabled: true,
          selected: NumberOfMonths === 1 ? 0 : 6,
          inputBoxWidth: 75,
          inputBoxHeight: 18,
          buttonTheme: {
            height: 18,
            padding: 2,
            undefined: 0,
            width: 15,
            Index: 7,
          },
        },
        title: {
          text: 'Current Profile',
        },
        xAxis: {
          type: 'datetime',
          min: obj.len > 0 && obj.min,
          max: obj.len > 0 && obj.max,
          plotBands: [
            {
              color: '#e6e9ef', // Color value
              from: obj.len > 0 && obj.selectedPoint, // Start of the plot band
              to: obj.len > 0 && obj.endPoint, // End of the plot band
            },
          ],
          plotLines: [
            {
              color: 'grey', // Color value
              value: obj.len > 0 && obj.selectedPoint,
              width: 1, // Width of the line
            },
            {
              color: 'grey',
              value: obj.len > 0 && obj.endPoint,
              width: 1,
            },
          ],
        },
        yAxis: {
          title: {
            text: 'Current (Amps)',
          },
        },
        legend: {
          enabled: true,
          layout: 'horizontal',
          align: 'center',
          verticalAlign: 'bottom',
        },
        exporting: {
          enabled: true,
          buttons: {
            contextButton: {
              menuItems: [
                'downloadPNG',
                'downloadJPEG',
                'downloadPDF',
                'downloadSVG',
                'separator',
                'downloadCSV',
                'downloadXLS',
                'viewData',
              ],
            },
          },
        },
        navigator: {
          enabled: false,
        },
        tooltip: {
          pointFormat:
            '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b><br/>',
          valueDecimals: 2,
          split: true,
        },
        credits: {
          enabled: false,
        },
        series: [
          {
            name: 'Current-R',
            color: chartRed,
            marker: { enabled: false, symbol: 'circle', radius: 2 },
            lineWidth: 2,
            data: obj.current_R,
          },
          {
            name: 'Current-Y',
            color: chartYellow,
            marker: { enabled: false, symbol: 'circle', radius: 2 },
            lineWidth: 2,
            data: obj.current_Y,
          },
          {
            name: 'Current-B',
            color: chartBlue,
            marker: { enabled: false, symbol: 'circle', radius: 2 },
            lineWidth: 2,
            data: obj.current_B,
          },
        ],
      },
      initialize: false,
    });
  }

  render() {
    return (
      <div>
        {this.state.initialize ? (
          <ChartLoader height="150" width="600" />
        ) : (
          <HighchartsReact
            highcharts={Highcharts}
            constructorType={'stockChart'}
            options={this.state.options}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  widgetSetting: state.WidgetSettingReducer,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CurrentProfile);
